import React, {FC} from 'react';
import {TextField} from "@mui/material";
import {observer} from "mobx-react";
import {useStorageUserConfigContext} from "@app/modules/UserConfig/contexts/storage";


type TProps = {
    // onChange(value: string)
    // className: string
}

export const UserPassword: FC<TProps> = observer((props: TProps) => {

    const {userConfigStore} = useStorageUserConfigContext()

    return <TextField type={"password"}
                      label={"Password"}
                      name={"user-password"}
                      autoComplete="new-password"
                      onChange={(e) => {
                          userConfigStore.userPassword = (e.target.value)
                      }}
                      value={userConfigStore.userPassword}
    />
})

